import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { Subscription } from 'rxjs';
import { SignInResponse } from 'src/app/constants/user-registration.model';
import { CommonService } from 'src/app/services/common.service';
import { UserRegistrationService } from 'src/app/services/user-registration.service';
declare const grecaptcha: any;

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
  notifier: NotifierService;
  loginRegisterText = '';
  error: boolean = false;
  displayPassword: boolean = false;
  displayConfirmPassword: boolean = false;
  displayType: string = 'signin';
  signInForm: FormGroup = new FormGroup({});
  registerForm: FormGroup = new FormGroup({});
  forgotEmail: FormControl = new FormControl('', [
    Validators.required,
    Validators.email
  ]);
  resetPasswordForm: FormGroup = new FormGroup({});
  showLoader: boolean = false;
  queryParamSubscription: Subscription;
  verificationToken: string = '';
  resetToken: string = '';
  registerSuccess: boolean = false;
  verifySuccess: boolean = false;
  resetPasswordSuccess: boolean = false;
  allianceId: string = '';
  recaptchaToken?: string;

  constructor(
    private router: Router,
    private userRegistrationService: UserRegistrationService,
    private route: ActivatedRoute,
    private commonService: CommonService,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
    this.queryParamSubscription = this.route.queryParams.subscribe({
      next: (params: Params) => {
        if (params['verify']) {
          this.verificationToken = params['verify'];
          this.showLoader = true;
          this.verifyUser();
          this.displayType = 'signin';
        } else if (params['reset']) {
          this.resetToken = params['reset'];
          this.displayType = 'reset';
        } else if (params['allianceId']) {
          this.displayType = 'register';
          this.allianceId = params['allianceId'];
        } else {
          this.displayType = 'signin';
        }
      }
    });
  }

  ngOnInit() {
    this.signInFormInit();
    this.registerFormInit();
    this.resetPasswordFormInit();
  }
  // ngAfterViewInit() {
  //   this.waitForRecaptcha();
  // }

  // waitForRecaptcha(attempts: number = 0) {
  //   if (
  //     typeof grecaptcha !== 'undefined' &&
  //     document.querySelector('.g-recaptcha')
  //   ) {
  //     console.log('reCAPTCHA script loaded — rendering now');
  //     grecaptcha.render(document.querySelector('.g-recaptcha')!, {
  //       sitekey: '6LeBkOwrAAAAALki9nGEHtGmFrEcEhaE0fmC9Suo',
  //     });
  //   } else {
  //     if (attempts < 10) {
  //       console.warn(' Waiting for reCAPTCHA to load...');
  //       setTimeout(() => this.waitForRecaptcha(attempts + 1), 500);
  //     } else {
  //       console.error(' reCAPTCHA failed to load after several attempts');
  //     }
  //   }
  // }

  signInFormInit() {
    this.displayPassword = false;
    this.error = false;
    this.signInForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required])
    });
  }

  resetPasswordFormInit() {
    this.displayPassword = false;
    this.displayConfirmPassword = false;
    this.error = false;
    this.resetPasswordForm = new FormGroup({
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(
          '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,}'
        )
      ]),
      confirmPassword: new FormControl('', [Validators.required])
    });
  }

  registerFormInit() {
    this.displayPassword = false;
    this.displayConfirmPassword = false;
    this.error = false;
    this.registerForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.email, Validators.required]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(
          '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,}'
        )
      ]),
      confirmPassword: new FormControl('', [Validators.required])
    });
  }

  forgotEmailInit() {
    this.error = false;
    this.forgotEmail = new FormControl('', [
      Validators.required,
      Validators.email
    ]);
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e: any): void {
    let element: any = document.querySelector('#sign-in__header');
    if (window.pageYOffset > element.clientHeight / 3) {
      element.classList.add('sign-in__header__whiteBackground');
    } else {
      element.classList.remove('sign-in__header__whiteBackground');
    }
  }

  signIn() {
    if (!this.showLoader) {
      this.showLoader = true;
      this.error = this.signInForm.invalid;
      if (!this.error) {
        this.userRegistrationService.signin(this.signInForm.value).subscribe({
          next: (response: SignInResponse) => {
            console.log(response);
            this.showLoader = false;
            // this.router.navigate(['/']);
            if (response.user_status === 0) {
              this.notifier.notify('error', 'Please verify email to login');
            } else if (response.user_status === 1) {
              localStorage['status'] = response.user_status;
              localStorage['accessToken'] = response.token;
              this.router.navigate(['/role-select']);
            } else if (response.user_status === 2) {
              this.notifier.notify(
                'warning',
                'Admin yet to approve your account'
              );
            } else if (response.user_status === 3) {
              localStorage['status'] = response.user_status;
              localStorage['roleId'] = response.role_id;
              localStorage['accessToken'] = response.token;
              this.commonService.setUserName('');
              this.commonService.setUserRole(response.role_id.toString());
              if (response.role_id === 3 || response.role_id === 4) {
                this.router.navigate(['/new-dashboard']);
              } else {
                this.router.navigate(['/dashboard']);
              }
            } else if (response.user_status === 4) {
              this.notifier.notify('error', 'Your account has been blocked');
            }
          },
          error: (error: any) => {
            console.log(error);
            this.showLoader = false;
            this.notifier.notify(
              'error',
              error.error === 'not verified'
                ? 'User not verified'
                : error?.error?.message || 'Unable to sign in user'
            );
          }
        });
      } else this.showLoader = false;
    }
  }

  register() {
    // const token = grecaptcha.getResponse();
    // if (!token) {
    //   this.notifier.notify('error', 'Please verify reCAPTCHA');
    //   return;
    // }

    // if (!this.showLoader) {
    //   this.showLoader = true;
    //   this.error = this.registerForm.invalid;
    //   if (!this.error) {
    //     this.error =
    //       this.registerForm.value.password !==
    //       this.registerForm.value.confirmPassword;
    //     if (this.error) {
    //       this.notifier.notify(
    //         'error',
    //         'Password and Confirm Password do not match'
    //       );
    //     }
    //   }
    if (this.showLoader) return;

    if (this.registerForm.invalid) {
      this.notifier.notify('error', 'Please fill all required fields');
      return;
    }

    if (
      this.registerForm.value.password !==
      this.registerForm.value.confirmPassword
    ) {
      this.notifier.notify(
        'error',
        'Password and Confirm Password do not match'
      );
      return;
    }

    this.showLoader = true;

    grecaptcha.ready(() => {
      grecaptcha
        .execute('6Lfh0cYtAAAAAIWoxaaiuetfZuPK4dhjzikt6jDA', {
          action: 'register'
        })
        .then((token: string) => {
          this.callRegisterAPI(token);
        })
        .catch(() => {
          this.showLoader = false;
          this.notifier.notify('error', 'reCAPTCHA verification failed');
        });
    });
  }
  //     if (!this.error) {
  //       this.userRegistrationService
  //         .registerUser({
  //           email: this.registerForm.value.email,
  //           password: this.registerForm.value.password,
  //           firstName: this.registerForm.value.firstName,
  //           lastName: this.registerForm.value.lastName,
  //           allianceId: this.allianceId,
  //           recaptchaToken: token,
  //         })
  //         .subscribe({
  //           next: (response: any) => {
  //             this.showLoader = false;
  //             grecaptcha.reset();
  //             if (response.msg === 'email address already exist') {
  //               this.notifier.notify('error', 'Email address already exist');
  //             } else {
  //               this.notifier.notify(
  //                 'success',
  //                 'User registered successfully! Please check your email for verification link'
  //               );
  //               // this.displayType = 'signin';
  //               this.registerSuccess = true;
  //               this.displayType = 'registerSuccess';

  //               setTimeout(() => {
  //                 this.router.navigate(['/register']);
  //               }, 10000);
  //             }
  //           },
  //           error: (error: any) => {
  //             this.showLoader = false;
  //             this.notifier.notify(
  //               'error',
  //               error?.error?.message || 'Unable to register user'
  //             );
  //           },
  //         });
  //     } else {
  //       this.showLoader = false;
  //     }
  //   }
  // }
  callRegisterAPI(token: string) {
    console.log('reCAPTCHA token:', token);
    this.userRegistrationService
      .registerUser({
        email: this.registerForm.value.email,
        password: this.registerForm.value.password,
        firstName: this.registerForm.value.firstName,
        lastName: this.registerForm.value.lastName,
        allianceId: this.allianceId,
        recaptchaToken: token
      })
      .subscribe({
        next: (response: any) => {
          this.showLoader = false;
          if (response.msg === 'email address already exist') {
            this.notifier.notify('error', 'Email address already exist');
          } else {
            this.notifier.notify(
              'success',
              'User registered successfully! Please check your email for verification link'
            );
            this.registerSuccess = true;
            this.displayType = 'registerSuccess';

            setTimeout(() => {
              this.router.navigate(['/register']);
            }, 10000);
          }
        },
        error: (error: any) => {
          this.showLoader = false;
          this.notifier.notify(
            'error',
            error?.error?.message || 'Unable to register user'
          );
        }
      });
  }

  resetPassword() {
    if (!this.showLoader) {
      this.showLoader = true;
      this.error = this.resetPasswordForm.invalid;
      if (!this.error) {
        this.error =
          this.resetPasswordForm.value.password !==
          this.resetPasswordForm.value.confirmPassword;
        if (this.error)
          this.notifier.notify(
            'error',
            'Password and Confirm Password do not match'
          );
      }
      if (!this.error) {
        this.userRegistrationService
          .resetPassword({
            token: this.resetToken,
            password: this.resetPasswordForm.value.password
          })
          .subscribe({
            next: (response: any) => {
              console.log(response);
              this.showLoader = false;
              this.notifier.notify(
                'success',
                'Successfully reset password! Please login with new password'
              );
              this.resetPasswordSuccess = true;
              this.verifySuccess = false;
              this.displayType = 'signin';
              // this.router.navigateByUrl('/sign-in');
            },
            error: (error: any) => {
              console.log(error);
              this.showLoader = false;
              this.notifier.notify(
                'error',
                error?.error?.message || 'Unable to reset password'
              );
            }
          });
      } else {
        this.showLoader = false;
      }
    }
  }

  forgotPassword() {
    if (!this.showLoader) {
      this.showLoader = true;
      this.error = this.forgotEmail.invalid;
      if (!this.error) {
        this.userRegistrationService
          .forgotPassword(this.forgotEmail.value)
          .subscribe({
            next: (response: any) => {
              console.log(response);
              this.showLoader = false;
              this.notifier.notify(
                'success',
                'Reset password link sent to your email'
              );
            },
            error: (error: any) => {
              console.log(error);
              this.showLoader = false;
              this.notifier.notify(
                'error',
                error?.error?.message || 'Unable to send reset password link'
              );
            }
          });
      } else {
        this.showLoader = false;
      }
    }
  }

  verifyUser() {
    this.userRegistrationService.verifyUser(this.verificationToken).subscribe({
      next: (response: any) => {
        console.log(response);
        this.showLoader = false;
        if (response.msg === 'not found') {
          this.notifier.notify('error', 'Unable to verify user');
        } else {
          this.notifier.notify('success', 'User verified successfully!');
          this.verifySuccess = true;
          this.resetPasswordSuccess = false;
        }
      },
      error: (error: any) => {
        console.log(error);
        this.notifier.notify(
          'error',
          error?.error?.message || 'Unable to verify user'
        );
      }
    });
  }
}
